<template>
  <div id="app" class="main">
    <table class="main-table" cellspacing="0">
      <tr>
        <td id="maincell">
          <!-- BEGIN LOGO SECTION -->
          <table class="outerTable" border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td class="black_stripe"></td>
            </tr>
            <tr>
              <td class="logoSection" bgcolor="#FFFFFF">
                <table border="0">
                  <tr>
                    <td>
                      <router-link to="/">
                        <img
                          class="logo"
                          src="./assets/images/lt_logo.gif"
                          width="350"
                          height="42"
                          alt
                          border="0"
                        />
                      </router-link>
                    </td>
                    <td class="navSection" style="text-align:right;">
                      <router-link to="/products">
                        <img
                          :src="selectedLink('products')"
                          width="73"
                          height="14"
                          alt
                          border="0"
                          @mouseover="swapImg('products', $event)"
                          @mouseout="swapImg('products', $event)"
                        />
                      </router-link>
                      <router-link to="/services">
                        <img
                          :src="selectedLink('services')"
                          width="73"
                          height="14"
                          alt
                          border="0"
                          @mouseover="swapImg('services', $event)"
                          @mouseout="swapImg('services', $event)"
                        />
                      </router-link>
                      <router-link to="/clients">
                        <img
                          :src="selectedLink('clients')"
                          width="73"
                          height="14"
                          alt
                          border="0"
                          @mouseover="swapImg('clients', $event)"
                          @mouseout="swapImg('clients', $event)"
                        />
                      </router-link>
                      <router-link to="/contact">
                        <img
                          :src="selectedLink('contact')"
                          width="73"
                          height="14"
                          alt
                          border="0"
                          @mouseover="swapImg('contact', $event)"
                          @mouseout="swapImg('contact', $event)"
                        />
                      </router-link>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class="greenBar">
              <td></td>
            </tr>
            <tr class="dottedLine">
              <td>
                <img
                  src="./assets/images/dotted_line.gif"
                  width="800"
                  height="1"
                  alt
                  border="0"
                />
              </td>
            </tr>
            <!-- END LOGO SECTION -->
            <router-view />
            <app-footer></app-footer>
          </table>

          <!-- END MAIN CONTENT AREA -->
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    appFooter: Footer
  },
  methods: {
    selectedLink(link) {
      let view = this._getView();
      let activeImage = view === link ? `${view}_s` : link;
      const url = require(`./assets/images/nav/${activeImage}.gif`);
      return url;
    },
    swapImg(name, event) {
      const view = this._getView();
      if (view !== name) {
        const on = require(`./assets/images/nav/${name}_s.gif`);
        const off = require(`./assets/images/nav/${name}.gif`);
        let image = event.type === "mouseover" ? on : off;
        event.target.src = image;
      }
    },
    _getView() {
      const href = window.location.href;
      const segments = href.split("/");
      let view = segments[segments.length - 1];
      return view;
    }
  }
};
</script>
<style>
@import "./assets/style.css";
#app {
  display: flex;
}
</style>
